export default __webpack_public_path__ + "static/media/wiki.73b1a29e.svg";